export function regFile(file, fileList, fileindex, item) {
	console.log(file.type,item.accept.toLowerCase());
  if (item.accept.toLowerCase() == '.mp4' && file.type == 'video/mp4') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error("请上传大小在 1000M 以内的文件");
      return false;
    } 
    // else if (file.size > 1024 * 1024 * 5000) {
    //   this.$message.error('请上传大小在 5G 以内的文件');
    //   return false;
    // }
  } else if (file.type == 'application/pdf' && item.accept.toLowerCase() == '.pdf') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  }else if (file.type == 'application/msword' && item.accept.toLowerCase() == '.doc,.docx') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  } else if ((file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type == 'application/pdf' || file.type == 'application/vnd.ms-excel' || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') && item.accept.toLowerCase() == '.pdf,.docx,.xls,.xlsx') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  } else if (file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && item.accept.toLowerCase() == '.doc,.docx') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  }else if ((file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type == 'application/pdf') && item.accept.toLowerCase() == '.pdf,.docx'){
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  }else{
    this.$message.warn('请上传正确格式的文件');
    return false;
  }
  // let nums = item.fileList.filter((item)=>{
  //   return item.fileType == '5' || item.fileType == '8' || item.fileType == '13'  || item.fileType == '19'
  // })
  let nums = item.fileList.filter((item)=>{
      return item.fileType == '1' 
  })
  let nums2 = item.fileList.filter((item)=>{
    return item.fileType == '2' 
  })
  let nums3 = item.fileList.filter((item)=>{
    return item.fileType == '3' 
  })
   let nums4 = item.fileList.filter((item)=>{
    return item.fileType == '4' 
  })
   let nums5= item.fileList.filter((item)=>{
    return item.fileType == '5' 
  })
   let nums6= item.fileList.filter((item)=>{
    return item.fileType == '6'
  })
   let nums7= item.fileList.filter((item)=>{
    return item.fileType == '7'
  })
   let nums8= item.fileList.filter((item)=>{
    return item.fileType == '8'
  })
  if(nums.length > 0){
    this.$message.warning('视频只能上传一个！');
    return false;
  }
  if(nums2.length > 0 || nums3.length > 0 || nums4.length > 0 || nums5.length > 0 || nums6.length > 0 || nums7.length > 0 || nums8.length > 0){
    this.$message.warning('文件只能上传一个！');
    return false;
  }
  this.handleUpload(fileindex, file);
}